import { observer } from 'mobx-react-lite';
import { Page } from '../../../components';
import BillingWidget from '../edit/billing';

export default observer(function BillingPage() {
  return (
    <Page navigation={{ title: 'Billing', icon: 'file-invoice-dollar' }}>
      <BillingWidget />
    </Page>
  );
});
